import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const CURRICULA = [
  { slug: 'NationalProgram', key: 'national' },
  { slug: 'BritishProgram', key: 'british' },
  { slug: 'AmericanProgram', key: 'american' },
]

export default function ProgramSidebar({ currentSlug }) {
  const { t } = useTranslation()

  return (
    <aside className="min-w-0 w-full max-w-full space-y-6 lg:sticky lg:top-28 lg:self-start">
      <div className="min-w-0">
        <h3 className="mb-3 text-sm font-bold uppercase tracking-widest text-primary lg:mb-4">
          {t('programSidebar.byCurriculum')}
        </h3>
        <ul className="flex min-w-0 max-w-full gap-2 overflow-x-auto pb-1 [scrollbar-width:none] lg:block lg:space-y-2 lg:overflow-visible lg:pb-0 [&::-webkit-scrollbar]:hidden">
          {CURRICULA.map(({ slug, key }) => (
            <li key={slug} className="shrink-0 lg:shrink">
              <Link
                to={`/pages/${slug}`}
                className={`block whitespace-nowrap rounded-lg px-3 py-2.5 text-sm transition-colors lg:whitespace-normal ${
                  currentSlug === slug
                    ? 'bg-primary text-white'
                    : 'border border-border/60 bg-white text-text/70 hover:border-primary/25 hover:bg-primary/5 hover:text-primary lg:border-0 lg:bg-transparent'
                }`}
              >
                {t(`programs.${key}.title`)}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="mb-3 text-sm font-bold uppercase tracking-widest text-primary lg:mb-4">
          {t('programSidebar.quickLinks')}
        </h3>
        <ul className="grid gap-2 text-sm sm:grid-cols-2 lg:grid-cols-1">
          <li>
            <Link to={`/pages/MisTlaAlAli`} className="text-accent hover:text-primary">
              {t('programSidebar.campusTlaAlAli')}
            </Link>
          </li>
          <li>
            <Link to={`/pages/MisKhalda`} className="text-accent hover:text-primary">
              {t('programSidebar.campusKhalda')}
            </Link>
          </li>
          <li>
            <Link to="/events" className="text-accent hover:text-primary">
              {t('programSidebar.enrolmentEvents')}
            </Link>
          </li>
          <li>
            <Link to="/news" className="text-accent hover:text-primary">
              {t('programSidebar.latestNews')}
            </Link>
          </li>
          <li className="sm:col-span-2 lg:col-span-1">
            <Link to="/pages/NationalProgram" className="text-accent hover:text-primary">
              {t('programSidebar.chooseCurriculum')}
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  )
}
